var render = function render(){var _vm=this,_c=_vm._self._c;return _c('table',{staticClass:"w-full"},[_c('thead',{staticClass:"text-2xl text-output-primary"},[_c('tr',{staticClass:"text-left"},_vm._l((_vm.table.headers),function(header,index){return _c('th',{key:index,class:[{ 'text-output-secondary': index === 0 }]},[_vm._v(" "+_vm._s(header)+" ")])}),0)]),_c('tbody',_vm._l((_vm.table.data),function(rowData,rowIndex){return _c('tr',{key:rowIndex,class:[
                'text-2xl',
                {
                    'text-output-primary': rowIndex % 2 !== 0,
                    'text-white bg-output-primary': rowIndex % 2 === 0
                }
            ]},[_vm._l((rowData),function(cellData,cellIndex){return [(typeof cellData !== 'boolean')?_c('td',{key:cellIndex,staticClass:"px-2 py-1"},[_vm._v(" "+_vm._s(cellData)+" ")]):_c('td',{key:cellIndex,class:{
                        'text-output-primary': rowIndex % 2 !== 0,
                        'text-white bg-output-primary': rowIndex % 2 === 0
                    }},[_vm._t("htmlContent",null,{"cell":{
                            index: cellIndex,
                            content: cellData
                        }})],2)]})],2)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }